// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormNote } from '~/utils/interface/note';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormNote> => {
  return yup.object().shape({
    businessId: yup.string().optional(),
    businessType: yup.string().optional(),
    type: yup.string().optional(),
    content: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
  });
};

export const defaultValuesNoteForm: IFormNote = {
  businessId: EMPTY_STRING,
  businessType: EMPTY_STRING,
  type: EMPTY_STRING,
  content: EMPTY_STRING,
};
